// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"06a3dd52","453":"5f295bdc","455":"8d9fd035","977":"a41ce550"}[chunkId] + ".chunk.js";
};